<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="division">
<div class="cover"><a href="#/nav#ncover"><img alt="cover image" id="cover" src="9780310355137_coverimage.jpg"/></a></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?70a9c60a